import { ObjectValues } from 'src/common/tsHelpers';

export const TABLE_VARIANT = {
  Combined: 0,
  Flat: 1,
} as const;

export type TableVariant = ObjectValues<typeof TABLE_VARIANT>;

export type ColumnConfiguration = {
  name: string;
  position: number;
  width: string;
  children: ColumnConfiguration[];
  enabled: boolean;
  sortable: boolean;
  isCustomField: boolean;
};

export type TableConfiguration = {
  enabledVariant: TableVariant;
  flatColumnConfigurations: ColumnConfiguration[];
  combinedColumnConfigurations: ColumnConfiguration[];
};

export type ColumnWidth = {
  columnName: string;
  width: string;
  isCustomField?: boolean;
};

export const getHeaderLabel = ({
  tableVariant,
  translations,
  columnName,
  isCustomField,
}: {
  tableVariant: TableVariant;
  translations: { combined: Record<string, string>; flat: Record<string, string> };
  isCustomField: boolean;
  columnName: string;
}) => {
  if (isCustomField) {
    return columnName;
  }

  if (tableVariant === TABLE_VARIANT.Combined) {
    return translations.combined[columnName];
  }

  return translations.flat[columnName];
};

export const DEFAULT_WIDTH = 130;

export const getColumnWidth = ({
  defaultColumnSize,
  width,
}: {
  defaultColumnSize: number;
  columnName: string;
  width: string;
}) => {
  if (width && width !== 'auto') {
    return +width;
  }

  return defaultColumnSize;
};

export const DEFAULT_COLUMN_MAX_WIDTH = 400;

export const getColumnMaxWidth = ({
  maxSizes,
  columnName,
}: {
  maxSizes: { [key: string]: number };
  columnName: string;
}) => {
  return maxSizes[columnName] || DEFAULT_COLUMN_MAX_WIDTH;
};
